
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import DateUtils from '@/common/js/DateUtils'
    import Enums from '@/lib/enums'
    import appconst from '@/lib/appconst';
    import { routers } from '@/router/router'
    import moment from 'moment'
    import storeaddressInfo from '@/store/entities/back-storeaddress-list'


    class AmountListRequest extends PageRequest {
        shipment: string;
        beginTime?: Date;
        endTime?: Date;
        storeId?: number;
    }


    @Component({
        name: "intologisticsrecord",
    })
    export default class Orders extends AbpBase {
        pagerequest: AmountListRequest = new AmountListRequest();
        storeaddressList: Array<storeaddressInfo> = [];
        creationTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];
        get list() {
            return this.$store.state.backintologistics.list;
        };
        get loading() {
            return this.$store.state.backintologistics.loading;
        }
        pageChange(page: number) {
            this.$store.commit('backintologistics/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('backintologistics/setPageSize', pagesize);
            this.getpage();
        }
        async getpage() {
            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
            if (this.creationTime.length > 0) {
                this.pagerequest.beginTime = this.creationTime[0];
            }
            if (this.creationTime.length > 1) {
                this.pagerequest.endTime = this.creationTime[1];
            }
            await this.$store.dispatch({
                type: 'backintologistics/getAll',
                data: this.pagerequest
            });
        }

        async getData() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            })
            var a = new storeaddressInfo();
            a.id = null;
            a.storeName = "全部";
            this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
            if (this.storeaddressList.length == 1) {
                this.pagerequest.storeId = this.storeaddressList[0].id;
            }
            else {
                this.storeaddressList.push(a);
                this.pagerequest.storeId = null;
            }

        }

        get pageSize() {
            return this.$store.state.backintologistics.pageSize;
        }
        get totalCount() {
            return this.$store.state.backintologistics.totalCount;
        }
        get currentPage() {
            return this.$store.state.backintologistics.currentPage;
        }
        async searchPage() {
            this.$store.state.backintologistics.currentPage = 1;
            this.getpage();
        }
        columns = [
            {
                title: '快递单号',
                width: 200,
                align: "center",
                key: 'shipment'
            },
            {
                title: '快递扫描人',
                key: 'userName',
                align: "center",
                width: 200,
            },
            {
                title: '备注',
                key: 'note',
                align: "center",
                width: 100,
            }, 
            {
                title: '仓库名称',
                align: "center",
                width: 200,
                render: (h: any, params: any) => {
                    return h('span', params.row.warehouseName ? params.row.warehouseName : params.row.storeName)
                }
            },{
                title: '创建时间',
                key: 'creationTime',
                align: "center",
                width: 200,
                render: (h: any, params: any) => {
                    return h('span', DateUtils.formatLongDate(new Date(params.row.creationTime)));
                }
            }]
        async created() {
            await this.getData();
            this.getpage();
        }
    }
